"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.safeWithLog = exports.safe = void 0;
function safe(fn, defaultValue) {
    if (defaultValue === void 0) { defaultValue = undefined; }
    var safeCall = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        try {
            return fn.apply(void 0, args);
        }
        catch (ex) {
            // tslint:disable-next-line:no-console
            console.error(ex);
            return defaultValue;
        }
    };
    return safeCall;
}
exports.safe = safe;
// tslint:disable-next-line:no-console
function safeWithLog(_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.defaultValue, defaultValue = _c === void 0 ? undefined : _c, _d = _b.loggingFunction, loggingFunction = _d === void 0 ? console.error.bind(console) : _d;
    // tslint:disable-next-line:only-arrow-functions
    return function (target, propertyKey, descriptor) {
        var fn = descriptor.value;
        descriptor.value = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            try {
                return fn.apply(this, args);
            }
            catch (ex) {
                loggingFunction("Error during call ".concat(target.constructor.name, ".").concat(propertyKey), ex);
                return defaultValue;
            }
        };
    };
}
exports.safeWithLog = safeWithLog;
//# sourceMappingURL=safe.js.map